// extracted by css-extract-rspack-plugin
export default {"FormField":"D3Zqe","FormFieldError":"LoOY8","FormLabel":"MOrQr","FormInput":"xG0K7","noFocus":"zigwA"};